<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="button__group m-b-xs-20">
                        <ak-button
                            size="small"
                            @click="backToGrid"
                        >
                            <i class="ak-icon ak-button__icon">arrow_left</i>
                            {{$t('Ga naar lijst')}}
                        </ak-button>
                    </div>
                </div>

                <template v-if="data !== null && data.isLocked" class="col-lg-12">
                  <div class="col-lg-12">
                    <div v-if="!loading" class="ak-panel ak-panel--no-padding m-b-xs-20">
                        <div class="ak-panel__header ak-panel__header--small ak-panel__header--success">
                            <div class="ak-panel__title">
                                {{ $t('Tickets toewijzen voor ') }} <strong>{{ data.product.title }}</strong>
                            </div>
                        </div>
                        <div class="ak-panel__body ak-panel__body--small reading">
                          <p class="text-success">
                            <i class="fa fa-check"></i>
                            {{ $t('Tickets werden reeds toegewezen. Aanpassingen zijn niet meer mogelijk.') }}
                          </p>
                        </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                    <div class="col-lg-9">
                        <div v-if="!loading" class="ak-panel ak-panel--no-padding m-b-xs-20">
                            <div class="ak-panel__header ak-panel__header--small ak-panel__header--success">
                                <div class="ak-panel__title">
                                    {{ $t('Tickets toewijzen voor ') }} <strong>{{ data.product.title }}</strong>
                                </div>
                            </div>
                            <div class="ak-panel__body ak-panel__body--small reading">
                                <div>
                                    <p v-if="data.pdfsOriginal.length">
                                      <strong>
                                        {{ $t('1. PDF-bestanden correct geïmporteerd. Excel-bestand kan gegenereerd worden.') }}
                                      </strong>
                                    </p>

                                    <p v-else class="text-warning">
                                        <i class="fa fa-warning"></i>
                                        {{ $t('Gelieve eerst PDF-bestand(en) te uploaden, alvorens de Excel-bestand te genereren.') }}
                                    </p>
                                    <ak-button
                                        v-if="data.pdfsOriginal.length"
                                        @click="exportExcel($event)">
                                        {{ $t('Exporteer nieuwe Excel-bestand.') }}
                                    </ak-button>
                                </div>
                                <div v-if="data.pdfsOriginal.length">
                                  <hr/>
                                  <p>
                                    <strong>
                                      {{ $t('2. Importeer ingevuld Excel-bestand') }}
                                    </strong>
                                  </p>
                                  <p  v-if="data.assigmentExcel == null" >
                                    <input
                                        colorMode="secondary"
                                        type="file"
                                        class="ak-form__control ak-form__control--prefix form-control"
                                        @change="uploadExcel()"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                        capture
                                        value="Voeg file toe"
                                        id="excel"
                                    />
                                  </p>
                                  <p v-else >
                                    <table v-if="!loading" class="ak-table ak-panel__table">
                                      <tbody>
                                        <tr class="ak-table-row">
                                          <td class="ak-table-column">
                                              <i class="muted">{{ $t('Ingevuld Excel-bestand') }}:</i>
                                          </td>
                                          <td class="ak-table-column">
                                              <a :href="`:/app-kit/assign-manual-tickets/download-excel/${data.assigmentExcel.id}`">
                                                  {{ data.assigmentExcel.originalFilename }}
                                              </a>
                                          </td>
                                          <td class="ak-table-column">
                                              <ak-button
                                                  size="small"
                                                  colorMode="error"
                                                  @click="deleteExcel(data.assigmentExcel)"
                                              >
                                                <i class="ak-icon ak-button__icon">delete</i>
                                            </ak-button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </p>
                                </div>
                                <div v-if="data.assigmentExcel != null">
                                    <hr/>
                                    <p>
                                      <strong>
                                        {{ $t('3. Valideer Excel-bestand') }}
                                      </strong>
                                    </p>
                                    <p class="muted fst-italic">{{ $t('Algemene validatie') }}</p>
                                    <table v-if="!loading" class="ak-table ak-panel__table">
                                      <tbody>
                                        <template v-for="validationData in data.validationData.line">
                                          <template v-if="data.showOk">
                                            <tr class="ak-table-row">
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                  <i class="muted">{{ $t('Lijn') }}: {{validationData.line}}</i>
                                              </td>
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                  {{validationData.order_code}}
                                              </td>
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                  {{validationData.user_name}}
                                              </td>
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                  {{validationData.amount}}
                                              </td>
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                  {{validationData.pdf}}
                                              </td>
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                  {{validationData.range}}
                                              </td>
                                              <td class="ak-table-column padding-5" style="padding: 5px">
                                                <template v-if="validationData.errors.length">
                                                  <ul>
                                                    <li
                                                      v-for="data in validationData.errors"
                                                      class="ak-table-row text-danger"
                                                    >
                                                      {{ data }}
                                                    </li>
                                                  </ul>
                                                </template>
                                                <template v-else>
                                                  <ul>
                                                    <li class="text-success">{{ $t('Ok !') }}</li>
                                                  </ul>
                                                </template>
                                              </td>
                                            </tr>
                                          </template>
                                        </template>
                                      </tbody>
                                    </table>

                                    <p class="muted fst-italic">{{ $t('Algemene validatie') }}</p>
                                    <ul>
                                      <template v-if="!data.validationData.file.length">
                                        <li class="text-success">{{ $t('Ok !') }}</li>
                                      </template>
                                      <template v-for="error in data.validationData.file">
                                        <li class="ak-table-row text-danger">
                                          {{ error }}
                                        </li>
                                      </template>
                                    </ul>

                                    <ak-button
                                        @click="validateExcel($event)">
                                        {{ $t('Valideer') }}
                                    </ak-button>
                                </div>
                                <div v-if="data.isValid">
                                  <hr/>
                                  <p>
                                    <strong>
                                      {{ $t('4. Tickets definitief toewijzen') }}
                                    </strong>
                                  </p>
                                  <ak-button
                                          @click="assignTickets()">
                                          {{ $t('Toewijzen') }}
                                  </ak-button>
                                </div>
                            </div>
                        </div>
                        <ak-loader size="large" :loading="loading" />
                    </div>
                    <div class="col-lg-3">
                        <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                            <div class="ak-panel__header ak-panel__header--small">
                                <div class="ak-panel__title">
                                    {{ $t('Voeg ticket PDF-bestand(en) toe') }}
                                </div>
                            </div>
                            <div class="ak-panel__body ak-panel__body--small reading">
                                <table v-if="!loading" class="ak-table ak-panel__table">
                                  <tbody>
                                      <tr
                                        v-for="pdf in data.pdfsOriginal"
                                        :key="pdf.id"
                                        class="ak-table-row"
                                      >
                                          <td class="ak-table-column">
                                              <i class="muted">{{ $t('Bestand') }}:</i>
                                          </td>
                                          <td class="ak-table-column">
                                              <a :href="`:/app-kit/assign-manual-tickets/download-pdf/${pdf.id}`">
                                                  {{ pdf.originalFilename }}
                                              </a>
                                          </td>
                                          <td class="ak-table-column">
                                              <ak-button
                                                  size="small"
                                                  colorMode="error"
                                                  @click="deletePdf(pdf)"
                                              >
                                                <i class="ak-icon ak-button__icon">delete</i>
                                            </ak-button>
                                          </td>
                                      </tr>
                                  </tbody>
                                </table>

                                <!-- File upload input -->
                              <div>
                                <input
                                    colorMode="secondary"
                                    type="file"
                                    class="ak-form__control ak-form__control--prefix form-control"
                                    @change="addPdf($event)"
                                    accept="application/pdf"
                                    capture
                                    value="Voeg file toe"
                                    id="files"
                                  />
                              </div>
                            </div>
                        </div>
                    </div>
                </template>


            </div>
        </div>
    </div>
</template>

<script>
import {toJSON} from "../../../../vendor/moment/src/lib/moment/to-type";

export default {
    name: 'AssignManualTickets',
    data() {
        return {
            data: null,
            isHandled: false,
            hasError: false,
            error: null,
            loading: false,
        }
    },
    watch: {
        '$route.params.hashId': {
            handler () {
                this.initialize();
            }
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            this.isHandled = false;
            this.hasError = false;
            this.error = null;
            const result = await this.$get('/assign-manual-tickets/' + this.$route.params.hashId);
            if (result.success) {
                this.data = result.data;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'product', gridDefinition: 'grid'}});
        },
        exportExcel() {
            window.location.href = this.$generateUrl('/assign-manual-tickets/generate-excel/' + this.$route.params.hashId);
        },
        async downloadPdf() {
            this.loading = true;
            await this.$get('/assign-manual-tickets/download-pdf/' + this.$route.params.hashId);
            this.loading = false;
            this.initialize();
        },
        async validateExcel() {
            this.loading = true;
            await this.$get('/assign-manual-tickets/validate-excel/' + this.$route.params.hashId);
            this.loading = false;
            this.initialize();
        },
        async addPdf($event) {
            console.log($event)

            var formData = new FormData()
            var file = document.getElementById('files').files[0]
            formData.append('file', file)

            this.loading = true;
            await fetch(this.$generateUrl('/assign-manual-tickets/add-pdf/' + this.$route.params.hashId), {
                method: 'POST',
                body: formData,
            });
            this.loading = false;
            this.initialize();
        },
        async uploadExcel() {
              var formData = new FormData()
              var file = document.getElementById('excel').files[0]
              formData.append('file', file)
              this.loading = true;
              await fetch(this.$generateUrl('/assign-manual-tickets/upload-excel/' + this.$route.params.hashId), {
                  method: 'POST',
                  body: formData,
              });
              this.loading = false;
              this.initialize();
          },
          async deletePdf($pdf) {
              this.loading = true;
              await this.$get('/assign-manual-tickets/delete-pdf/' + $pdf.id);
              this.loading = false;
              this.initialize();
          },
          async deleteExcel($excel) {
              this.loading = true;
              await this.$get('/assign-manual-tickets/delete-excel/' + $excel.id);
              this.loading = false;
              this.initialize();
          },
          async assignTickets() {
              this.loading = true;
              await this.$get('/assign-manual-tickets/assign-tickets/' + this.$route.params.hashId);
              this.loading = false;
              this.initialize();
          }
    },
    created() {
        this.initialize();
    }
}
</script>